// Redux stuff
import { connect } from 'react-redux';
import { resetChoices } from '../actions/choicesActions';
import { setCurrentBranch } from '../actions/branchActions';

// ui
import BranchSwitch from './BranchSwitch';


const mapStateToProps = state => {
    return {
        branches: state.branches
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setCurrentBranch: (id) => { 
            dispatch(resetChoices());
            dispatch(setCurrentBranch(id)); 
        }
    };
};

/**
  * Redux container for the BranchSwitch component
  *
  */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BranchSwitch);